import { CloseOutlined, DeleteOutlined, DownOutlined, EditOutlined, PlusOutlined, RightOutlined, SaveOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { Button, Form, Input, message, Space, Spin, Switch, Table } from "antd";
import { serverFetch } from "@server";
import { renderNumber, renderSwitch } from "@extensions/helper";
import { useViewportBreakpoint } from "../../hooks/useViewportBreakpoint";
import CompanyBaseItem from "./company-base-item";

const CompanyBase = ({ id, onClose }) => {
  const viewport = useViewportBreakpoint();
  const isMobile = viewport === "mobile";
  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState();
  const [users, setUsers] = useState([]);
  const [form] = Form.useForm();
  const [selected, setSelected] = useState(null);
  /** Мобилка: какая карточка дилера в режиме редактирования (null — только просмотр) */
  const [editingId, setEditingId] = useState(null);
  const getData = () => {
    setLoading(true);
    serverFetch(`db/${id}`)
      .then(data => {
        setItem(data);
        setLoading(false);
        setUsers((data.scheme.factory.users ?? []).map((item, idx) => ({ ...item, id: idx + 1 })));
        form.setFieldsValue(data);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };
  useEffect(getData, [form, id]);
  useEffect(() => {
    if (!isMobile) setEditingId(null);
  }, [isMobile]);
  const onValuesChange = value => setItem({ ...item, ...value });
  const onSave = () => {
    setLoading(true);
    serverFetch("db", {
      method: "PUT",
      bodyData: { ...item, scheme: { ...item.scheme, factory: { ...item.scheme.factory, users } } },
    })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };
  const onCancel = () => onClose(false);
  const onChangeDiler = value => setItem({ ...item, scheme: { ...item.scheme, diler: { ...item.scheme.diler, ...value } } });
  const onChangeFactory = value =>
    setItem({ ...item, scheme: { ...item.scheme, factory: { ...item.scheme.factory, ...value } } });
  const columns = [
    Table.SELECTION_COLUMN,
    { dataIndex: "id" },
    { title: "Акт.", dataIndex: "isAct", render: renderSwitch, align: "center" },
    { title: "Пользователь", dataIndex: "name" },
    { title: "Настройки", dataIndex: "isNstr", render: renderSwitch, align: "center" },
    { title: "Коэфф.", dataIndex: "coeff", align: "center" },
    { title: "Пакеты", dataIndex: "isPack", render: renderSwitch, align: "center" },
    { title: "С отдела", dataIndex: "depnoOld", align: "center" },
    { title: "На отдел", dataIndex: "depnoNew", align: "center" },
    { title: "Комментарий", dataIndex: "comment" },
    Table.EXPAND_COLUMN,
  ];
  const onRowClick = rowId => (selected === rowId ? setSelected(null) : setSelected(rowId));
  const onItemClose = newItem => {
    if (isMobile) setEditingId(null);
    else setSelected(null);
    if (newItem) {
      if (newItem.id) setUsers(users.map(u => (u.id === newItem.id ? newItem : u)));
      else
        setUsers([
          ...users.filter(u => u.id),
          { ...newItem, id: users.length > 1 ? users[users.length - 2].id + 1 : 1 },
        ]);
    }
  };
  const onItemAdd = () => {
    setUsers([...users.filter(i => i.id), { id: 0 }]);
    if (isMobile) setEditingId(0);
    else setSelected(0);
  };
  const onItemDelete = rowId => {
    setUsers(users.filter(i => i.id !== rowId));
    setSelected(null);
    setEditingId(null);
  };
  const formProps = isMobile
    ? { layout: "vertical", colon: false, disabled: loading, style: { width: "100%", maxWidth: "100%" } }
    : { labelCol: { span: 8 }, wrapperCol: { span: 24 }, colon: false, disabled: loading, style: { maxWidth: 800 } };
  const formFields = (
    <>
      <Form.Item label="Наименование" name="name">
        <Input />
      </Form.Item>
      {isMobile ? (
        <Form.Item label="">
          <div className="company-base-switch-row">
            <span>Удалена</span>
            <Form.Item name="isDel" valuePropName="checked" noStyle>
              <Switch />
            </Form.Item>
          </div>
        </Form.Item>
      ) : (
        <Form.Item label="Удалена" name="isDel" valuePropName="checked">
          <Switch />
        </Form.Item>
      )}
      <Form.Item className="company-base-pre-section" label="Код базы" name="guid">
        <Input />
      </Form.Item>
      <Form.Item className="company-base-section-heading" label=" ">
        <div>
          <strong>ДИЛЕР</strong>
        </div>
      </Form.Item>
      <Form.Item label="Получать настройки">
        <Input
          placeholder="Телефон +7XXXXXXXXXX или почта"
          value={item?.scheme.diler.nstr}
          onChange={e => onChangeDiler({ nstr: e.target.value })}
        />
      </Form.Item>
      <Form.Item className="company-base-pre-section" label="Отправлять пакеты">
        <Input
          placeholder="Телефон +7XXXXXXXXXX или почта"
          value={item?.scheme.diler.pack}
          onChange={e => onChangeDiler({ pack: e.target.value })}
        />
      </Form.Item>
      <Form.Item className="company-base-section-heading company-base-factory-heading" label=" ">
        <div>
          <strong>ПРОИЗВОДИТЕЛЬ / ПОСТАВЩИК</strong>
        </div>
      </Form.Item>
      <Form.Item className="company-base-factory-switch" label=" ">
        {isMobile ? (
          <div className="company-base-switch-row">
            <span>Предоставлять настройки всем пользователям</span>
            <Switch
              checked={item?.scheme.factory.defaultLoad}
              onChange={checked => onChangeFactory({ defaultLoad: checked })}
            />
          </div>
        ) : (
          <Space align="center">
            <Switch
              checked={item?.scheme.factory.defaultLoad}
              onChange={checked => onChangeFactory({ defaultLoad: checked })}
            />
            <span>Предоставлять настройки всем пользователям</span>
          </Space>
        )}
      </Form.Item>
      <Form.Item className="company-base-pre-section" label="Коэфф. прайса по умолч.">
        <Input
          style={{ maxWidth: 100 }}
          value={item?.scheme.factory.defaultCoeff}
          onChange={e => onChangeFactory({ defaultCoeff: e.target.value })}
        />
      </Form.Item>
      {isMobile ? (
        <Form.Item className="company-base-section-heading company-base-dilery-heading" label="">
          <div className="company-base-dilery-row">
            <strong>ДИЛЕРЫ</strong>
            <Button type="primary" icon={<PlusOutlined />} onClick={onItemAdd} aria-label="Добавить" className="company-base-add-diler-btn" />
          </div>
        </Form.Item>
      ) : (
        <>
          <Form.Item className="company-base-section-heading" label=" ">
            <div>
              <strong>ДИЛЕРЫ</strong>
            </div>
          </Form.Item>
          <Form.Item label="">
            <Button onClick={onItemAdd}>Добавить</Button>
          </Form.Item>
        </>
      )}
      {isMobile ? (
        <Spin spinning={loading}>
          <div className="company-base-dilers-list">
            {users.map(record => (
              <div key={record.id} className="company-base-dilers-card-wrap">
                {editingId === record.id ? (
                  <div className="company-base-dilers-card company-base-dilers-card--editing">
                    <CompanyBaseItem
                      key={record.id}
                      variant="mobile"
                      onClose={onItemClose}
                      itemDefault={record}
                    />
                  </div>
                ) : (
                  <div className="company-base-dilers-card company-base-dilers-card--view">
                    <div className="company-base-dilers-card-header">
                      <div className="company-base-dilers-card-header-main">
                        <Switch
                          checked={!!record.isAct}
                          disabled
                          size="small"
                          aria-label="Активный"
                        />
                        <span className="company-base-dilers-card-name">{record.name ?? ""}</span>
                      </div>
                      <div className="company-base-dilers-card-header-actions">
                        <Button
                          type="default"
                          size="small"
                          icon={<EditOutlined />}
                          className="company-base-dilers-edit-btn"
                          onClick={e => {
                            e.stopPropagation();
                            setEditingId(record.id);
                          }}
                          aria-label="Изменить"
                        />
                        <Button
                          danger
                          type="default"
                          size="small"
                          icon={<DeleteOutlined />}
                          className="company-base-dilers-delete-btn"
                          onClick={e => {
                            e.stopPropagation();
                            onItemDelete(record.id);
                          }}
                          aria-label="Удалить"
                        />
                      </div>
                    </div>
                    {record.comment?.trim() ? (
                      <div className="company-base-dilers-card-comment">{record.comment.trim()}</div>
                    ) : null}
                    <div className="company-base-dilers-card-meta">
                      <div className="company-base-dilers-card-row">
                        <div className="company-base-dilers-card-row-main">
                          <span className="company-base-dilers-card-meta-label">Настройки</span>
                          <span className="company-base-dilers-card-coeff">{renderNumber(record.coeff) ?? "—"}</span>
                        </div>
                        <Switch checked={!!record.isNstr} disabled size="small" />
                      </div>
                      <div className="company-base-dilers-card-row">
                        <div className="company-base-dilers-card-row-main">
                          <span className="company-base-dilers-card-meta-label">Пакеты</span>
                          <span className="company-base-dilers-card-dep">
                            {record.depnoOld ?? "—"} → {record.depnoNew ?? "—"}
                          </span>
                        </div>
                        <Switch checked={!!record.isPack} disabled size="small" />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </Spin>
      ) : (
        <Table
          columns={columns}
          dataSource={users}
          rowKey="id"
          pagination={false}
          loading={loading}
          size="small"
          expandable={{
            expandedRowRender: record => (
              <CompanyBaseItem onClose={onItemClose} itemDefault={record} onDelete={onItemDelete} />
            ),
            expandedRowKeys: selected == null ? [] : Array.isArray(selected) ? selected : [selected],
            onExpand: (expanded, record) => setSelected(expanded ? record.id : null),
            expandIcon: ({ expanded, onExpand, record }) =>
              expanded ? (
                <DownOutlined onClick={e => onExpand(record, e)} />
              ) : (
                <RightOutlined onClick={e => onExpand(record, e)} />
              ),
            rowExpandable: () => true,
          }}
          onRow={record => ({ onClick: () => onRowClick(record.id) })}
          rowSelection={{
            type: "radio",
            selectedRowKeys: selected == null ? [] : Array.isArray(selected) ? selected : [selected],
            renderCell: checked => <div className={checked ? "misoft-list-indicator" : ""} />,
          }}
        />
      )}
      <Form.Item />
      {!isMobile && (
        <Form.Item label=" ">
          <Space>
            <Button className="misoft-btn" onClick={onSave}>
              Сохранить
            </Button>
            <Button className="misoft-btn" onClick={onCancel}>
              Отмена
            </Button>
          </Space>
        </Form.Item>
      )}
    </>
  );
  return (
    <div>
      <div
        className={`misoft-modal-overlay${isMobile ? " company-base-overlay--mobile" : ""}`}
        onClick={e => e.target === e.currentTarget && onClose(false)}
      >
        <div
          className={`misoft-modal-content${isMobile ? " company-base-sheet--mobile" : ""}`}
          style={isMobile ? undefined : { width: 800 }}
          onClick={e => e.stopPropagation()}
        >
          {isMobile ? (
            <>
              <div className="company-base-sheet-header">
                <span className="company-base-sheet-title">База</span>
                <Space size="small" className="company-base-sheet-actions">
                  <Button
                    type="primary"
                    icon={<SaveOutlined />}
                    onClick={onSave}
                    loading={loading}
                    aria-label="Сохранить"
                    className="company-base-header-icon-btn"
                  />
                  <Button
                    type="default"
                    icon={<CloseOutlined />}
                    onClick={() => onClose(false)}
                    aria-label="Закрыть"
                    className="company-base-header-icon-btn"
                  />
                </Space>
              </div>
              <div className="company-base-sheet-body">
                <Form form={form} onValuesChange={onValuesChange} {...formProps}>
                  {formFields}
                </Form>
              </div>
            </>
          ) : (
            <>
              <div className="misoft-modal-title">
                <span>База</span>
                <CloseOutlined
                  className="misoft-section-title-close"
                  onClick={() => onClose()}
                  style={{ zIndex: 9, color: "#2f6f00", fontSize: 16 }}
                />
              </div>
              <Form form={form} onValuesChange={onValuesChange} {...formProps}>
                {formFields}
              </Form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default CompanyBase;
